<template>

    <div id="js-user-wrap" class="container">
        <el-form :model="userEdit" :rules="rules" ref="userEdit" label-width="100px"
                 :class="{ editForm: editUserInfo }">
            <el-card class="box-card">
                <div slot="header" class="clearfix">
                    <span class="box-card-title">个人信息</span>
                    <router-link to="/home">
                        <el-button size="small" type="primary">返回</el-button>
                    </router-link>
                    <el-button size="small" @click="faceCertify()" v-if="!editUserInfo && 1 !== user.faceCertify" type="danger">认证</el-button>
                    <el-button size="small" v-if="!editUserInfo" type="primary" @click="edit">编辑</el-button>
                    <el-button size="small" @click="submitForm('userEdit')" v-if="editUserInfo" type="primary">保存</el-button>
                </div>
                <div class="text item">
                    <el-row>
                        <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
                            <el-form-item label="邮箱">
                                <span>{{ user.email }}</span>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
                            <el-form-item label="实名状态">
                                <span v-if="1===user.faceCertify"><i class="el-icon-star-on color-primary"></i>已认证</span>
                                <span v-if="-1===user.faceCertify"><i class="el-icon-star-on color-primary"></i>已认证</span>
                                <span v-if="0===user.faceCertify"><i class="el-icon-star-off color-primary"></i>未认证</span>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
                            <el-form-item label="姓名" prop="chName">
                                <span v-if="!editUserInfo || 1===user.faceCertify">{{ user.chName }}</span>
                                <el-input v-model="userEdit.chName" v-if="editUserInfo && 0===user.faceCertify"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
                            <el-form-item label="身份证号码" prop="certNo">
                                <span v-if="!editUserInfo || 1===user.faceCertify">{{ user.certNo }}</span>
                                <el-input v-model="userEdit.certNo" v-if="editUserInfo && 0===user.faceCertify"></el-input>
                            </el-form-item>
                        </el-col>

                    </el-row>
                    <el-row>
                        <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
                            <el-form-item label="姓名拼音" prop="enName" >
                                <span v-if="!editUserInfo">{{ user.enName }}</span>
                                <el-col :span="12" style="width: 40%">
                                <el-tooltip v-if="editUserInfo" class="item" effect="light"
                                            content="名字拼音,将用于制作证书。例如：Xiaoming"
                                            placement="right">
                                    <el-input placeholder="Xiaoming" style="width: 100%" v-model="userEdit.firstName"
                                              v-if="editUserInfo"></el-input>
                                </el-tooltip>
                                </el-col>
                                <el-col :span="12" style="width: 40%">
                                    <el-tooltip v-if="editUserInfo" class="item" effect="light"
                                                content="姓氏拼音，将用于制作证书。例如:Wang"
                                                placement="right">
                                        <el-input placeholder="Wang" style="width: 100%"  v-model="userEdit.lastName"
                                                  v-if="editUserInfo"></el-input>
                                    </el-tooltip>
                                </el-col>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
                            <el-form-item label="手机号码" prop="tel">
                                <span v-if="!editUserInfo">{{ user.tel }}</span>
                                <el-input v-model="userEdit.tel" v-if="editUserInfo"></el-input>
                            </el-form-item>
                        </el-col>

                    </el-row>
                    <el-row>
                        <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
                            <el-form-item label="单位" prop="company">
                                <span v-if="!editUserInfo">{{ user.company }}</span>
                                <el-input v-model="userEdit.company" v-if="editUserInfo"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
                            <el-form-item label="职务" prop="title">
                                <span v-if="!editUserInfo">{{ user.title }}</span>
                                <el-input v-model="userEdit.title" v-if="editUserInfo"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
                            <el-form-item label="培训机构" prop="institutions">
                                <span v-if="!editUserInfo">{{ user.institutions }}</span>
                                <el-input v-model="userEdit.institutions" v-if="editUserInfo"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </div>
            </el-card>
        </el-form>

<!--        <el-dialog title="支付宝扫码认证" width="20%" :visible="faceCertifyVisible" center @close="closeFaceCertify">-->
<!--            <div style="text-align: center" @click="refreshCertifyUrl()">-->
<!--                <vue-qr  logoSrc="/alipay.png"  :text="faceCertifyUrl" :size="150" :margin="0" ></vue-qr>-->
<!--            </div>-->
<!--            <div style="text-align: center;color:red">-->
<!--                <p>若人脸识别认证失败，请检查个人信息页面的姓名/身份证号码是否准确</p>-->
<!--            </div>-->
<!--        </el-dialog>-->

        <el-card class="box-card">
            <div slot="header" class="clearfix">
                <span class="box-card-title">修改密码</span>
            </div>
            <div class="text item">
                <el-form :model="changePassword" :rules="formRules" ref="changePassword" label-width="100px"
                         :class="{ editForm: editUserInfo }">
                    <el-form-item label="原始密码" prop="password">
                        <el-input v-model="changePassword.password" type="password"></el-input>
                    </el-form-item>
                    <el-form-item label="新密码" prop="newPassword">
                        <el-input v-model="changePassword.newPassword" type="password"></el-input>
                    </el-form-item>
                    <el-form-item label="确认密码" prop="newPassword_">
                        <el-input v-model="changePassword.newPassword_" type="password"
                                  @keyup.enter.native="update"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button size="small" type="primary" class="large-bt" @click="update">修改密码</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </el-card>
    </div>

</template>
<script>
import VueQr from 'vue-qr'
export default {
    components:{VueQr},
    data() {
        var confirmPasswordValidator = (rule, value, callback) => {
            if (value !== this.changePassword.newPassword) {
                callback(new Error("两次输入密码不一致!"));
            } else {
                callback();
            }
        };

        var isSamePasswordValidator = (rule, value, callback) => {
            if (value === this.changePassword.password) {
                callback(new Error("新密码和原始密码不可一致!"));
            } else {
                callback();
            }
        };
        const Validatetel = (rule, value, callback) => {
            const reg = new RegExp(/^(?:\+?86)?1[3-9]\d{9}$|^(?:\+?852)?[569]\d{7}$|^(?:\+?853)?6\d{7}$|^(?:\+?886)?9\d{8}$/);
            if (!reg.test(value)) {
                callback(new Error("手机号格式不正确"));
            } else {
                callback();
            }
        };

        return {
            editUserInfo: false,
            user: {},
            userEdit: this.user,
            formRules: {
                password: [
                    {required: true, message: "请输入新密码", trigger: ["blur"]}
                ],
                newPassword: [
                    {required: true, message: "请输入新密码", trigger: ["blur"]},
                    {validator: isSamePasswordValidator, trigger: ["blur"]}
                ],
                newPassword_: [
                    {required: true, message: "请再次输入密码", trigger: ["blur"]},
                    {validator: confirmPasswordValidator, trigger: ["blur"]}
                ]
            },
            changePassword: {
                password: "",
                newPassword: "",
                newPassword_: ""
            },
            rules: {
                chName: [{required: true, message: "请输入姓名", trigger: "blur"}],
                certNo: [{required: true, message: "请输入身份证号码", trigger: "blur"}],
                firstName: [
                    {required: true, message: "请输入名字拼音", trigger: "blur"}
                ],
                lastName: [
                    {required: true, message: "请输入姓氏拼音", trigger: "blur"}
                ],
                tel: [
                    {required: true, message: "请输入手机号码", trigger: "blur"},
                    {validator: Validatetel, trigger: "blur"}
                ],
                company: [
                    {required: true, message: "请输入单位名称", trigger: "blur"}
                ],
                title: [
                    {required: true, message: "请输入职务", trigger: "blur"}
                ],
                institutions: []
            },
            faceCertifyVisible: false,
            faceCertifyUrl: null,

        };
    },
    methods: {
        logOut() {
            this.$axios.get("/logout").then(response => {
                this.$store.commit("updateUserInfo", null);
                sessionStorage.removeItem("userInfo");
                // this.$router.replace("/login");
            });
        },
        update() {
            this.$refs["changePassword"].validate(valid => {
                if (valid) {
                    this.$axios
                        .post("/user/updatePassword", {
                            newPassword: this.changePassword.newPassword,
                            password: this.changePassword.password
                        })
                        .then(res => {
                            if (res.code === 200) {
                                this.$message({
                                    message: "密码重置成功,请重新登录",
                                    type: "success"
                                });
                                this.logOut();
                            }
                        });
                }
            });
        },
        edit() {
            this.userEdit = JSON.parse(JSON.stringify(this.user));
            const i = this.userEdit.enName===null? -1: this.userEdit.enName.lastIndexOf(" ");
            this.userEdit.firstName = i > 0? this.userEdit.enName.substring(0,i):this.userEdit.enName;
            this.userEdit.lastName = i > 0 ? this.userEdit.enName.substring(i + 1, this.userEdit.enName.length) : "";
            this.editUserInfo = true;
        },
        submitForm(formName) {
            this.$refs[formName].validate(valid => {
                if (valid) {
                    const loading = this.$loading({
                        lock: true,
                        text: "保存中",
                        spinner: "el-icon-loading",
                        background: "rgba(0, 0, 0, 0.7)"
                    });
                    this.userEdit.enName = (this.userEdit.firstName+" "+this.userEdit.lastName).trim();
                    this.$axios
                        .post("/user/updateUser", this.userEdit)
                        .then(res => {
                            if (res.code === 200) {
                                loading.close();
                                this.editUserInfo = false;
                                this.user = JSON.parse(JSON.stringify(this.userEdit));
                                this.$message({
                                    message: "保存成功",
                                    type: "success"
                                });
                                this.$store.commit("updateUserInfo", this.user);
                                sessionStorage.setItem("userInfo", JSON.stringify(this.user));
                            }
                        })
                        .catch(err => {
                            loading.close();
                        })
                        .finally(() => {
                            loading.close();
                        });
                } else {
                    return false;
                }
            });
        },
        // async faceCertify() {
        //     if (null === this.user.certNo || null === this.user.chName) {
        //         this.$confirm('请先完善个人信息','错误', {confirmButtonText: '确定', type:'error'}).catch(err=> Promise.resolve(false));
        //         return;
        //     }
        //
        //     const loading = this.$loading({
        //         lock: true,
        //         text: "加载中",
        //         spinner: "el-icon-loading",
        //         background: "rgba(0, 0, 0, 0.7)"
        //     });
        //     let faceCertifyRes = await  this.$axios.get("/user/faceCertify");
        //     loading.close();
        //
        //     if (faceCertifyRes.code !== 200) {
        //         this.$message.error(faceCertifyRes.errMsg);
        //         return;
        //     }
        //
        //     this.faceCertifyUrl = faceCertifyRes.data.url;
        //     this.faceCertifyVisible = true;
        //
        //     this.faceCertifyResultSync = setInterval(  () => {
        //         this.faceCertifyQuery(faceCertifyRes.data.certifyId)
        //     }, 2000);
        // },
        async faceCertify() {
            if (null === this.user.certNo || null === this.user.chName) {
                this.$confirm('请先完善个人信息','错误', {confirmButtonText: '确定', type:'error'}).catch(err=> Promise.resolve(false));
                return;
            }

            const loading = this.$loading({
                lock: true,
                text: "加载中",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)"
            });
            let res = await this.$axios.post(`/user/faceCertify2`,
                {
                    type: 0,
                    route: '/user',
                    metaInfo:window.getMetaInfo()})
            loading.close();
            if (200 === res.code && null != res.data && null !== res.data.certifyUrl) {
                window.location.href = res.data.certifyUrl;
            } else {
                this.$message.error("获取人脸认证链接失败")
            }
            // if (faceCertifyRes.code !== 200) {
            //     this.$message.error(faceCertifyRes.errMsg);
            //     return;
            // }
            //
            // this.faceCertifyUrl = faceCertifyRes.data.url;
            // this.faceCertifyVisible = true;
            //
            // this.faceCertifyResultSync = setInterval(  () => {
            //     this.faceCertifyQuery(faceCertifyRes.data.certifyId)
            // }, 2000);
        },
        // async refreshCertifyUrl() {
        //     window.clearInterval(this.faceCertifyResultSync);
        //     await this.$axios.get("/user/clearFaceCertifyCache");
        //     await this.faceCertify();
        // },
        // closeFaceCertify() {
        //     this.faceCertifyVisible=false;
        //     window.clearInterval(this.faceCertifyResultSync);
        // },
        // async faceCertifyQuery(certifyId) {
        //     if (localStorage.getItem("user_"+certifyId)) {
        //         return;
        //     }
        //     let res = await this.$axios.get(`/user/faceCertifyResult?certifyId=${certifyId}`);
        //     if (res.code === 200 && res.data) {
        //         window.clearInterval(this.faceCertifyResultSync);
        //         localStorage.setItem("user_"+certifyId,certifyId)
        //         this.faceCertifyVisible= false;
        //
        //         res = await  this.$axios.get("/user/getCurrentUser").catch(err => {return {}});
        //         if (res.code === 200) {
        //             this.$store.commit("updateUserInfo", res.data);
        //             sessionStorage.setItem("userInfo", JSON.stringify(res.data));
        //             this.user = res.data;
        //         }
        //     } else if (res.code !== 200){
        //         window.clearInterval(this.faceCertifyResultSync);
        //     }
        // }
    },
    async mounted() {

        let url = new URL(window.location.href);
        let response = decodeURIComponent(url.searchParams.get('response'))
        if (response && 'null' !== response) {
            let params = JSON.parse(response);
            if (params.code !== 1000) {
                await  this.$confirm(`人脸识别失败：${params.reason}`, '提示', {
                    confirmButtonText: '确定',
                    showCancelButton: false,
                    showClose: false,
                    type: 'warning'
                });
            } else {
                const loading = this.$loading({
                    lock: true,
                    text: "正在确认人脸识别结果...",
                    spinner: "el-icon-loading",
                    background: "rgba(0, 0, 0, 0.7)"
                });
                let res = await this.$axios.get(`/user/faceCertifyResult2?certifyId=${params.extInfo.certifyId}`);
                loading.close()
            }

            window.location.href = `${window.location.protocol}//${window.location.host}/#/user`;
        }
    },
    async created() {
        let res = await  this.$axios.get("/user/getCurrentUser").catch(err => {return {}});
        this.user = res.data;
    }
};
</script>


<style scoped>
.container {
    margin-left: auto;
    margin-right: auto;
    max-width: 960px;
}

.box-card {
    width: 100%;
    margin-top: 10px;
}

span {
    padding-left: 16px;
    font-size: 14px;
    color: #333;
}

.el-input {
    width: 80%;
}

button {
    float: right;
    margin-left: 20px;
}

@media screen and (max-width: 767px) {
    .el-card {
        box-shadow: none;
        border: none;
    }
}
</style>
